import React from 'react';
import { User } from '@core/generated/gql-types';
import {
  OnboardingProgress,
  LatestNote,
  CandidateDetails,
  ClassificationLevelsPanel,
  CandidateReliability,
  CandidateSummary,
  PersonalInformation,
  VevoWorkEntitlement,
} from './components';
import { isFeatureEnabled } from '@/utils/featureFlags';
import { useCoreLoopConfigurationStore } from '@core/coreLoopConfiguration/useCoreLoopConfigurationStore';

interface DetailsProps {
  worker: User;
  onViewNotes: () => void;
}

const Details: React.FC<DetailsProps> = ({ worker, onViewNotes }) => {
  const displayReliabilityScore = useCoreLoopConfigurationStore(
    (state) =>
      state.coreLoopConfigurationItems?.displayReliabilityScore === true,
  );

  return (
    <div className="space-y-6">
      <OnboardingProgress worker={worker} />
      <LatestNote worker={worker} onViewNotes={onViewNotes} />
      <CandidateDetails worker={worker} />
      <ClassificationLevelsPanel worker={worker} />
      {displayReliabilityScore ? (
        <CandidateReliability worker={worker} />
      ) : null}
      {isFeatureEnabled('candidateSummary') && (
        <CandidateSummary worker={worker} />
      )}
      <PersonalInformation worker={worker} />
      <VevoWorkEntitlement worker={worker} />
    </div>
  );
};

export default Details;
